import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { InspirationRoomsResultModel } from '../../../models/InspirationRoomsResultModel';
import { InspirationRoomModel } from '../../../models/InspirationRoomModel';
import { Observable } from 'rxjs';
import { InspirationRoomOptionModel } from '../../../models/InspirationRoomOptionModel';
import { Appointment, Area, Option } from '../../../engine/models/models';
import { InspirationRoomTipsModel } from '../../../models/InspirationRoomTipsModel';

@Injectable()
export class InspirationRoomService {
  constructor(private http: HttpClient) {
  }

  updateRoom(room: InspirationRoomModel) {
    return this.http.put<InspirationRoomModel>(`${environment.api}/api/InspirationRoom`, room);
  }

  addUpdateRoomOptions(option: InspirationRoomOptionModel) {
    return this.http.put<InspirationRoomOptionModel>(`${environment.api}/api/InspirationRoom/options`, option);
  }

  addUpdateRoomTip(option: InspirationRoomTipsModel) {
    return this.http.put<InspirationRoomTipsModel>(`${environment.api}/api/InspirationRoom/tips`, option);
  }

  updateLiked(contractId: number, optionId: number, isLiked: boolean, optionType: string) {
    return this.http.put<any>(`${environment.api}/api/Selection/${contractId}/${optionId}/${isLiked}/${optionType}`, null);
  }

  getRoomByRoomId(id: number, code: string) {
    return this.http.get<InspirationRoomModel>(`${environment.api}/api/InspirationRoom/${id}/${code}`);
  }

  listInspirationRooms(): Observable<any> {
    return this.http.get<any>(`${environment.api}/api/InspirationRoomSelection`);
  }

  visualizable(optionId: number, areaId: number) {
    return this.http.get<boolean>(`${environment.api}/api/InspirationRoomSelection/${optionId}/${areaId}`);
  }


  updateJson(model: Appointment) {
    return this.http.put<Appointment>(`${environment.api}/api/Options`, model);
  }

  loadMedia(params: HttpParams) {
    return this.http.get<InspirationRoomsResultModel>(`${environment.api}/api/InspirationRoom?${params}`);
  }

  loadAreas() {
    return this.http.get<Area[]>(`${environment.api}/api/InspirationRoom/getAreas`);
  }

  deleteRoom(roomId: number): Observable<Response> {
    return this.http.put<Response>(`${environment.api}/api/InspirationRoom/DeleteRoom/${roomId}`, null);
  }

  getOptions(communityId: number, lot: string) {
    return this.http.get<Option[]>(`${environment.api}/api/InspirationRoom/options/${lot}/${communityId}`);
  }
  getTips() {
    return this.http.get<InspirationRoomTipsModel[]>(`${environment.api}/api/InspirationRoom/tips`);
  }
  exportInspirationRooms(params: HttpParams) {
    return this.http.get<any>(`${environment.api}/api/PDF/exportInspirationRooms?${params}`);
  }
}
